<template>
  <household-browser search />
</template>

<script>
import HouseholdBrowser from '@/components/HouseholdBrowser'

export default {
  name: 'HouseholdsIndex',
  components: {
    HouseholdBrowser
  },
  data: () => ({
  
  })
}
</script>